import { enumNever } from "src/shared/helpers/generalHelpers";
import CommentBubble from "../components/CommentBubble";
import CommentPhotoHeader from "../components/CommentPhotoHeader";
import CommentsEmpty from "../components/CommentsEmpty";
import CommentsUnreadIndicator from "../components/CommentsUnreadIndicator";
import { CommentsThreadRowType } from "../types";

export const commentThreadKeyExtractor = (item: CommentsThreadRowType.OneOf) => {
	return item.itemKey;
};
const renderCommentThreadItem = ({ item }: { item: CommentsThreadRowType.OneOf }) => {
	switch (item.variant) {
		case "CommentBubble":
			return <CommentBubble {...item.commentBubble} />;
		case "UnreadIndicator":
			return <CommentsUnreadIndicator />;
		case "PhotoHeader":
			return <CommentPhotoHeader item={item} />;
		case "Empty":
			return <CommentsEmpty />;
		default:
			return enumNever(item);
	}
};
export default renderCommentThreadItem;
